import { useContext } from "react";
import { BundleBuilderPreview } from "../../apps/Bundles/BundleBuilder/BundleBuilderBundle/BundleBuilderBundle";
import { AppConfigContext } from "../../context/AppConfigContext";
import { BundleBuilderConfigInterface } from "../../apps/Bundles/Types";
import CustomModal from "../CustomModal/CustomModal";

interface Props_BBmodal {
    open: boolean;
    onClose: () => void;
    bundleConfig: BundleBuilderConfigInterface;
}

const BundleBuilderModalPreview = ({ open, onClose, bundleConfig }: Props_BBmodal) => {
    const appConfigContext = useContext(AppConfigContext);

    return (
        <CustomModal open={open} title={"Bundle Builder Desktop Preview"} onClose={onClose} size="large">
            <div
                style={{
                    padding: "0px 20px",
                    zoom: 0.9,
                }}
            >
                <BundleBuilderPreview
                    standAlone={false}
                    appConfigContext={appConfigContext}
                    bundleConfig={bundleConfig}
                    previewType={2}
                />
            </div>
        </CustomModal>
    );
};

export default BundleBuilderModalPreview;
